<script setup lang="ts">
import ServiceSettingAdd from "@/views/playground/planner/order-management/service-setting/add/ServiceSettingAdd.vue";
</script>

<template>
  <service-setting-add></service-setting-add>
</template>

<style scoped></style>
